module.exports = BrowserFS.BFSRequire('path');



//////////////////
// WEBPACK FOOTER
// ./~/browserfs/dist/shims/path.js
// module id = 28
// module chunks = 0